"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undef */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
* MIND CONTACT FORM SETTINGS PAGE
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/
var mcf_field_1 = __importDefault(require("./mcf-field"));
var Mind_Contact_Public = /** @class */ (function () {
    /**
     * The array of actions registered with WordPress.
     * @since    1.0.0
     */
    function Mind_Contact_Public(el_mcf_container) {
        var _this = this;
        // set false for localhost none captcha development. Don't forget to put back to true when going public
        this.captcha_check = true;
        this.contact_ajax_obj = window.contact_ajax_obj;
        console.log('CONTACT AJAX OBJ JE');
        console.log(this.contact_ajax_obj);
        // DATA VALIDATION REGEXPS
        this.val_regs = {
            // eslint-disable-next-line no-useless-escape
            email: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
        };
        this.status_on = false; // check whether the status screen is on
        this.el_cont = el_mcf_container;
        this.el_submit = this.el_cont.querySelector('.submit');
        this.el_status = this.el_cont.querySelector('.mcf-status-cont');
        this.status_message = this.el_status.querySelector('.mcf-message-span');
        this.el_loader = this.el_status.querySelector('.mcf-loader');
        this.Fields = this.array_instances();
        this.captcha = this.el_cont.getAttribute('data-sitekey');
        this.el_submit.addEventListener('click', function (e) {
            _this.form_submit(e);
        });
    }
    /**
     * Public function Init ()
     * Loops through the given container element and sets all the necessary HTML Components as variables
     * @return Void
     */
    Mind_Contact_Public.prototype.init = function () {
        console.log('INITIALIZING MIND CONTACT FORM');
    };
    //  MAIN PARENT SUBMIT METHOD
    Mind_Contact_Public.prototype.form_submit = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.captcha_check === true) {
            grecaptcha.ready(function () {
                grecaptcha.execute(_this.captcha, { action: 'submit' }).then(function ( /*token: string*/) {
                    _this.check_and_post();
                });
            });
        }
        else
            this.check_and_post();
    };
    Mind_Contact_Public.prototype.check_and_post = function () {
        var _this = this;
        new Promise(function (resolve, reject) {
            _this.Fields.forEach(function (Field) {
                if (!Field.check())
                    return reject('FAILURE');
            });
            return resolve('success');
        }).then(function () {
            _this.status(_this.contact_ajax_obj.loading, 'loading');
            _this.data_send();
        }, function (reason) {
            console.log(reason);
        });
    };
    /**
     * ARRAY_INSTANCES
     * Returns an Array of class „Field” Instances.
     * @since 1.2
     */
    Mind_Contact_Public.prototype.array_instances = function () {
        var _this = this;
        var arr_fields = [];
        var html_fields = this.el_cont.querySelectorAll('.field');
        html_fields.forEach(function (html_field) {
            arr_fields.push(new mcf_field_1["default"](html_field, _this.val_regs));
        });
        return arr_fields;
    };
    Mind_Contact_Public.prototype.data_collect_json = function () {
        var values = {};
        this.Fields.map(function (f) {
            values[f.name] = f.el_input.value;
        });
        return (JSON.stringify(values));
    };
    Mind_Contact_Public.prototype.data_send = function () {
        var _this = this;
        var data = this.data_collect_json();
        var request = new XMLHttpRequest();
        var captcha = this.captcha_check ? grecaptcha.getResponse() : false;
        request.open('POST', this.contact_ajax_obj.ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                console.log(request.response);
                var resp = JSON.parse(request.response);
                resp.message = resp.message.replace(/\\/g, '');
                console.log(resp.message);
                _this.status(resp.message, resp.type);
            }
            else {
                _this.status(request.response, 'error');
                console.log(request.response);
            }
        };
        request.onerror = function () {
            _this.status(request.response, 'error');
        };
        request.send('action=contact_action&_ajax_nonce=' + this.contact_ajax_obj.nonce + '&captcha=' + captcha + '&data=' + data);
    };
    Mind_Contact_Public.prototype.escapeHtml = function (html) {
        var text = document.createTextNode(html);
        var p = document.createElement('p');
        p.appendChild(text);
        return p.innerHTML;
    };
    Mind_Contact_Public.prototype.display_el = function (el, display) {
        if (el) {
            el.style.display = display;
        }
        else {
            // error message
        }
    };
    Mind_Contact_Public.prototype.reset_form = function () {
        this.clean_status();
        this.hide_status();
        this.Fields.map(function (f) {
            f.reset();
            f.empty();
        });
    };
    /**
     * ARRAY_INSTANCES
     * Handles the frontend communication with user.
     * @since 1.2
     */
    Mind_Contact_Public.prototype.status = function (message, type) {
        this.clean_status();
        if (!this.status_on) {
            this.show_status();
            this.status_on = true;
        }
        switch (type) {
            case 'loading':
                console.log(message);
                this.display_el(this.el_loader, 'block');
                this.print_message(message, 'info');
                break;
            case 'error':
                this.print_message(message, 'error');
                this.show_reset_button();
                break;
            default:
                this.print_message(message, type);
                break;
        }
    };
    Mind_Contact_Public.prototype.show_reset_button = function () {
        console.log('show reset button here');
    };
    Mind_Contact_Public.prototype.print_message = function (m, t) {
        switch (t) {
            case 'error':
                t = 'has-text-danger';
                break;
            case 'success':
                t = 'has-text-success';
        }
        this.status_message.innerHTML = m;
        this.status_message.classList.add(t);
    };
    Mind_Contact_Public.prototype.clean_status = function () {
        this.display_el(this.el_loader, 'none');
        //this.display_el ( this.el_reset, 'none' );
        this.status_message.innerHTML = '';
        this.status_message.setAttribute('class', '');
    };
    Mind_Contact_Public.prototype.show_status = function () {
        //TODO add class to appear;
        this.el_status.style.display = 'flex';
    };
    Mind_Contact_Public.prototype.hide_status = function () {
        this.el_status.style.display = 'none';
    };
    return Mind_Contact_Public;
}());
exports["default"] = Mind_Contact_Public;
